import { createEffect, createSignal, on, onMount } from "solid-js";

import { useGetUserShareUrl } from "@/api/clientApi/user";
import { userStore } from "@/stores/userStore";

export const useShare = () => {
  const [shareLink, setShareLink] = createSignal("");
  const [shareCode, setShareCode] = createSignal("");
  // 接口初始化
  const getUserShareUrl = async () => {
    if (!userStore.isLogin) {
      setShareLink("");
      setShareCode("");
      return;
    }
    const res = await useGetUserShareUrl({});
    if (res) {
      // 原逻辑：分享逻辑与分享菜单逻辑不同，所以需要区分，源代码合并
      let shareLink = res.url;
      if (shareLink && !shareLink.startsWith("http")) {
        const domain = window.location.origin;
        shareLink = domain + shareLink;
      }

      setShareLink(shareLink);
      setShareCode(res.code);
    }
  };

  onMount(() => getUserShareUrl());

  createEffect(
    on(
      () => userStore.isLogin,
      () => getUserShareUrl(),
    ),
  );

  return {
    shareLink,
    shareCode,
  };
};
